export default {
  primary: '#182F3F',
  warning: '#EB8338',
  white: '#ffffff',
  background: '#F5F8FA',
  dark: '#444444',
  border: '#384F5F',
  textLight: '#9899AC',
  text: '#323248',
  line: '#E0E2EC',
  borderLight: '#E4E6EF'
};
